import { Image as ImageType } from '@yleisradio/areena-types';
import Image from 'next/image';
import { defaultLoader, loaderUrl } from 'utils/images';
import React from 'react';
import styles from './ChannelHeader.module.scss';

interface ChannelImageProps {
  image: ImageType;
  alt: string;
}

// Temporary: use white (_vt) logo variant instead of color (_vtc/_vtx) for contrast
function toWhiteLogo(image: ImageType): ImageType {
  return { ...image, id: image.id.replace(/_vt[cx]$/, '_vt') };
}

export const ChannelImage: React.FunctionComponent<ChannelImageProps> = ({
  image,
  alt,
}) => {
  return (
    <Image
      key={image.id}
      alt={alt}
      height={32}
      width={150}
      loader={defaultLoader}
      src={loaderUrl(toWhiteLogo(image))}
      className={styles.image}
      priority
    />
  );
};
